import { render, staticRenderFns } from "./cDocumentVersionCompareTagSummary.vue?vue&type=template&id=3784bcbe&scoped=true"
import script from "./cDocumentVersionCompareTagSummary.vue?vue&type=script&lang=js"
export * from "./cDocumentVersionCompareTagSummary.vue?vue&type=script&lang=js"
import style0 from "./cDocumentVersionCompareTagSummary.vue?vue&type=style&index=0&id=3784bcbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3784bcbe",
  null
  
)

export default component.exports